import React from 'react';
import { motion } from 'framer-motion';

const PILLARS = [
  {
    title: 'Stream Doping',
    detail:
      'Invisible, dynamic signatures embedded at the source. Cannot be detected, located, or removed. Works across every distribution path: broadcast, OTT, CDN.',
  },
  {
    title: 'Real-Time Forensics',
    detail:
      'Continuous monitoring identifies leaked streams and traces them to the exact source account within seconds. Automated. No manual monitoring required.',
  },
  {
    title: 'Always-On Protection',
    detail:
      'Kinesight runs continuously across your entire content pipeline, not just during high-profile events. Every stream is doped from ingestion through delivery, 24/7/365. No activation step, no scheduling, no protection gaps between events. The system is always doping, always monitoring, always enforcing. Pirates cannot wait for a window. There isn’t one.',
  },
  {
    title: 'Continuous Authentication',
    detail:
      'Session validation throughout the stream, not just at login. Credential sharing and account compromise are detected and acted on in real time.',
  },
  {
    title: 'Legacy + Modern Coverage',
    detail:
      'Works with both traditional broadcast infrastructure and modern IP-streamed content. Integration requires broadcasters to be “somewhat modern”. The bar is low.',
  },
];

const Pillar = ({ title, detail, index }) => (
  <motion.article
    initial={{ opacity: 0, x: -20 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true, margin: '-10%' }}
    transition={{ delay: 0.05 * index, duration: 0.7 }}
    className="relative grid grid-cols-12 gap-6 py-14 md:py-16 border-t border-white/5"
  >
    <div className="col-span-12 md:col-span-4 flex items-start gap-5">
      <span className="mt-3 h-12 w-[3px] bg-teal/80 flex-shrink-0" />
      <div>
        <h3 className="font-display text-2xl md:text-4xl text-white font-semibold tracking-tight leading-tight">
          {title}
        </h3>
      </div>
    </div>
    <div className="col-span-12 md:col-span-8 md:pl-10">
      <p className="text-lg md:text-xl text-white/85 font-normal leading-[1.6] max-w-2xl">
        {detail}
      </p>
    </div>
  </motion.article>
);

const Section07Technology = () => {
  return (
    <section className="section-pad section-glass" id="technology">
      <div className="container-edge">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex flex-col gap-6 mb-20 md:mb-24 max-w-4xl"
        >
          <h2 className="font-display font-bold text-white leading-[0.95] tracking-tight text-section">
            Depth without<br />
            <span className="text-teal">jargon.</span>
          </h2>
          <p className="editorial-body max-w-2xl">
            Five capabilities. One continuous platform that never switches off.
            Every piece designed to remove the pirate&rsquo;s economics,
            not just their URL.
          </p>
        </motion.div>

        <div>
          {PILLARS.map((p, i) => (
            <Pillar key={p.title} {...p} index={i} />
          ))}
          <div className="h-px w-full bg-white/5" />
        </div>
      </div>
    </section>
  );
};

export default Section07Technology;
